<template>
  <div class="back">
    <img class="pointer" @click="handleBack()" src="@/assets/thdImg/pages/back.svg" alt="" />
    <span class="back_name">{{ activityData.title }}</span>
  </div>
</template>

<script>
export default {
  name: "activeType",
  components: {},
  props: {
    activityData: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  created() {
    console.log(this.$route.query, 555);
  },
  methods: {
    handleBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  padding-left: 28px;
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f2f2f2;
  &_name {
    margin-left: 10px;
    font-size: 18px;
    font-weight: bold;
  }
}
</style>
